<div class="flex row p-1 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">
        APR Historical Records
    </div>
    <div>
        <button mat-dialog-close>
            <ng-container [ngTemplateOutlet]="closedIcon"></ng-container>
        </button>
    </div>
</div>
<hr class="my-0">

<mat-dialog-content #pageContainer style="max-height: 71vh;padding: 5px;">

    <div class="text-center text-3xl py-4">
        <b>{{ wellDetails.stringLongName }}</b>
    </div>

    <form [formGroup]="searchForm">
        <div class="flex justify-end w-full mb-3">
            <div class="flex justify-around">
                <div class="w-17 mx-2">
                    <mat-form-field class="w-full">
                        <mat-select formControlName="PageSize">
                            <mat-option [value]="10"> 10 </mat-option>
                            <mat-option [value]="20"> 20 </mat-option>
                            <mat-option [value]="50"> 50 </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <button class="btn btn-outline" (click)="downloadHistoricalApr()">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                    </svg>
                </button>
            </div>
        </div>
    </form>

    <div class="grid overflow-x-auto">
        <!-- Header -->
        <div class="table-annlus-pressure-record-list-grid z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
            matSort matSortDisableClear>
            <div class="border py-8 text-center">
                No
            </div>

            <div [mat-sort-header]="'fieldLongName'"
                class="flex justify-center border py-4 my-custom-sort-header">
                Field
            </div>

            <div [mat-sort-header]="'platformLongName'" class="flex justify-center border py-4">
                Platform
            </div>

            <div [mat-sort-header]="'wellLongName'" class="flex justify-center border py-4">
                Well
            </div>

            <div [mat-sort-header]="'stringLongName'" class="flex justify-center border py-4">
                Well String
            </div>

            <div [mat-sort-header]="'stringIndicatorShortName'" class="flex border justify-center py-4">
                String Indicator
            </div>

            <div [mat-sort-header]="'prodStatus'" class="flex border justify-center py-4">
                Production Status
            </div>

            <div [mat-sort-header]="'activity'" class="flex border justify-center py-4">
                Activity Type
            </div>

            <div [mat-sort-header]="'recordDate'" class="flex border justify-center py-4">
                Activity Date
            </div>

            <div [mat-sort-header]="'thp'" class="flex border justify-center py-4">
                THP
            </div>

            <div class="block col-span-4 text-center border pt-4">
                Annulus Pressure Reading (psi)

                <div class="grid grid-cols-4 text-sm font-normal mt-3">
                    <div class="border text-center py-2">A</div>
                    <div class="border text-center py-2">B</div>
                    <div class="border text-center py-2">C</div>
                    <div class="border text-center py-2">D</div>
                </div>
            </div>

            <div class="block border text-center py-8">
                Remarks
            </div>

        </div>
        <!-- Rows -->
        <ng-container *ngIf="dt.rows.length; else noRecords">
            <ng-container *ngFor="let row of dt.rows; let i = index; trackBy: trackByFn;">
                <div class="table-annlus-pressure-record-list-grid grid items-center border-b"
                    [ngClass]="{'bg-primary-100': i % 2 }">

                    <!-- No -->
                    <div class="py-4 text-center">
                        {{startingIndex + i + 1}}.
                    </div>

                    <!-- Field Long Name -->
                    <div class="flex truncate justify-center">
                        {{ row.fieldLongName }}
                    </div>

                    <!-- Platform Long Name  -->
                    <div class="flex justify-center">
                        {{ row.platformLongName }}
                    </div>

                    <!-- Well Long Name  -->
                    <div class="flex justify-center">
                        {{ row.wellLongName }}
                    </div>

                    <!-- String Long Name  -->
                    <div class="text-center">
                        {{ row.stringLongName }}
                    </div>

                    <!-- String Indicator -->
                    <div class="block text-center">
                        {{ row.stringIndicatorShortName }}
                    </div>

                    <!-- Production Status -->
                    <div class="block text-center">
                        {{ row.prodStatus }}
                    </div>

                    <!-- Activity -->
                    <div class="block text-center">
                        {{ row.activity }}
                    </div>

                    <!-- Activity Date -->
                    <div class="block text-center">
                        {{ handleFormatDate(row['recordDate'],true) }}
                    </div>

                    <!-- THP -->
                    <div class="block text-center">
                        {{ row.thp }}
                    </div>

                    <!-- Annulus Pressure Reading A–D -->
                    <div class="text-center">
                        {{ row.annAPress }}
                    </div>
                    <div class="text-center">
                        {{ row.annBPress }}
                    </div>
                    <div class="text-center">
                        {{ row.annCPress }}
                    </div>
                    <div class="text-center">
                        {{ row.annDPress }}
                    </div>

                    <!-- Remarks -->
                    <div class="block text-center">
                        {{ row.remarks || '-' }}
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <ng-template #noRecords>
            <div class="p-8 sm:p-16 text-2xl sm:text-2xl font-semibold tracking-tight text-center">
                There are no Annulus Pressure Records registered!
            </div>
        </ng-template>
    </div>

    <div
        class="flex justify-between inset-x-0 bottom-0 border-b border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent">
        <div class="content-center px-3">
            {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ? 'total' : 'totals' }} </div>

                <mat-paginator class="bg-gray-50" [ngClass]="{'pointer-events-none': isLoading}"
                    [length]="dt.page?.totalRecords" [pageIndex]="dt.page.offset" [pageSize]="dt.page.size"
                    [hidePageSize]="true" [showFirstLastButtons]="true">
                </mat-paginator>
        </div>
</mat-dialog-content>


<ng-template #closedIcon>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
</ng-template>